import { Book } from '../types';
import { priceValue, formatBookPrice, isHorsSerie } from '../context/CartContext';

/**
 * Génère un bon de commande au format Word (.doc) reprenant le template du
 * fichier « 04_Minihi_Levenez_Bon_de_commande.docx » et le télécharge.
 *
 * On produit du HTML compatible Word (MIME application/msword) : le fichier
 * s'ouvre directement dans Word / LibreOffice, reste éditable et imprimable,
 * sans dépendance externe.
 */
export const downloadBonDeCommande = (items: Book[]): void => {
  const total = items.reduce((sum, b) => sum + priceValue(b), 0);

  const rows = items
    .map(
      (b, i) => `
      <tr>
        <td style="padding:4px 0;">${i + 1}/ ${escapeHtml(
        isHorsSerie(b) ? 'Hors-série – ' : `N° ${b.edition_num} – `
      )}${escapeHtml(b.title)}</td>
        <td style="padding:4px 0; text-align:right; white-space:nowrap;">
          Prix ${escapeHtml(formatBookPrice(b))}
        </td>
      </tr>`
    )
    .join('');

  const html = `<!DOCTYPE html>
<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
<head>
  <meta charset="utf-8">
  <title>Bon de commande – Minihi Levenez</title>
  <!--[if gte mso 9]><xml><w:WordDocument><w:View>Print</w:View></w:WordDocument></xml><![endif]-->
  <style>
    body { font-family: 'Calibri', Arial, sans-serif; font-size: 12pt; color: #000; }
    h1 { font-size: 16pt; margin: 0; }
    h2 { font-size: 13pt; font-weight: normal; margin: 2pt 0 16pt; }
    table { width: 100%; border-collapse: collapse; }
    .total { font-weight: bold; margin: 16pt 0; border-top: 1px solid #000; padding-top: 8pt; }
    .field { margin: 10pt 0; }
    .muted { color: #333; }
  </style>
</head>
<body>
  <h1>Minihi Levenez</h1>
  <h2>Follenn prena – Bon de commande</h2>

  <p><strong>Felloud a ra din prena al leordiou-mañ :</strong><br>
  <em>Je souhaite commander les livres suivants :</em></p>

  <table>${rows}</table>

  <p class="total">En oll / Total ..... ${formatEuro(total)} €</p>

  <p class="muted">
    Displega a ran amañ dindan e-pelec'h ema al leoriou da veza kaset ha penaoz e payan anezo.<br>
    <em>Je précise ci-dessous l'adresse où doivent être expédiés les livres et mon mode de paiement.</em>
  </p>

  <p class="field">Ano, Nom ……………………......................... Ano bihan, Prénom …………..............……………...</p>
  <p class="field">Chomlec'h, Adresse ………………………………………..................................………………….</p>
  <p class="field">Pellgomz, Téléphone ……………………………….................................…………………………</p>
  <p class="field">Mail …………………………………………….................................……………………………..</p>

  <p><strong>Treuskas a ran ar priz da / Je paie par virement à :</strong><br>
  IBAN : ………………………………………………………………………………………………</p>

  <p>Kas a ran eur chekenn da, <em>Je joins mon chèque à l'ordre de Minihi Levenez.</em><br>
  4 rue du Minihi, 29800 Tréflévénez.</p>

  <p class="muted">
    Evid kaoud titourou, goulenn dre mail da,
    <em>Pour tout renseignement, s'adresser par mail à :</em> revue.minihi@gmail.com
  </p>
</body>
</html>`;

  const blob = new Blob(['﻿', html], { type: 'application/msword' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'Bon_de_commande_Minihi_Levenez.doc';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const escapeHtml = (s: string): string =>
  s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const formatEuro = (n: number): string =>
  Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
